module.exports = __webpack_public_path__ + "static/media/6_r_stulia_70.16_76.11.b0a04094.png";